import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Link } from '@sorare/routing';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LinkOverlay } from '@sorare/core/src/atoms/navigation/Box';
import { BodyM, HeadlineM, LabelM } from '@sorare/core/src/atoms/typography';
import { NBA_PLAY } from '@sorare/core/src/constants/__generated__/routes';
import { glossary } from '@sorare/core/src/lib/glossary';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

import { LobbyTile } from '@sorare/gameplay/src/components/home/LobbyTile';

import checkNbaBackground from './assets/checkNbaBackground.jpg';
import mobileBg from './assets/mobileBg.jpg';

const Wrapper = styled(LobbyTile)`
  width: 100%;
  height: 205px;
  display: flex;
  position: relative;
  flex-direction: column;
  gap: var(--unit);
  justify-content: flex-end;
  background: url(${mobileBg}) top/cover no-repeat;

  @media ${laptopAndAbove} {
    background: url(${checkNbaBackground}) top/cover no-repeat;
  }

  & > * {
    z-index: 1;
  }

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: var(--double-unit);
    background: linear-gradient(to top, var(--c-nl-900), transparent 50%);
  }
`;

export const CheckNbaTile = () => {
  return (
    <Wrapper
      neon
      label={
        <LabelM bold color="var(--c-nl-100-opaque)">
          <FormattedMessage
            id="CheckNbaTile.label"
            defaultMessage="Basketball"
          />
        </LabelM>
      }
      outlineColor="#8B1FF6"
    >
      <LinkOverlay as={Link} to={NBA_PLAY}>
        <Vertical>
          <Vertical gap={0}>
            <HeadlineM>
              <FormattedMessage
                id="CheckNbaTile.title"
                defaultMessage="Can’t wait to play?"
              />
            </HeadlineM>
            <BodyM color="var(--c-nd-700)">
              <FormattedMessage
                id="CheckNbaTile.subtitle"
                defaultMessage="Play NBA today for a chance to win rewards daily!"
              />
            </BodyM>
          </Vertical>
          <span>
            <Button size="small" color="secondary">
              <FormattedMessage {...glossary.playNow} />
            </Button>
          </span>
        </Vertical>
      </LinkOverlay>
    </Wrapper>
  );
};
